module.exports = __webpack_public_path__ + "static/media/PRATIC - LAVANDERIA.35d7ecfd.pdf";